import PropTypes from 'prop-types';
import React from 'react';
import { PvBox } from 'styles/CustomComponents';
import DrivingApplicantsSearch from './DrivingApplicantsSearch';
import LessonStatusSearch from './LessonStatusSearch';
import TheoryApplicantsSearch from './TheoryApplicantsSearch';
import TheoryLessonsSearch from './TheoryLessonsSearch';
import LessonsEditSearch from './LessonsEditSearch';
import LessonsReportSearch from './LessonsReportSearch';

const SEARCH_COMPONENTS = {
  LESSON_STATUS: LessonStatusSearch,
  DRIVING_BOOKING_APPLICANTS: DrivingApplicantsSearch,
  THEORY_BOOKING_APPLICANTS: TheoryApplicantsSearch,
  THEORY_BOOKING_LESSONS: TheoryLessonsSearch,
  LESSONS_EDIT: LessonsEditSearch,
  LESSONS_REPORT: LessonsReportSearch,
};

const Search = (props) => {
  const SpecificSearch = SEARCH_COMPONENTS[props.searchType];
  return (
    <PvBox my={3}>
      <SpecificSearch {...props} />
    </PvBox>
  );
};

Search.propTypes = {
  searchType: PropTypes.oneOf(['LESSON_STATUS', 'DRIVING_BOOKING_APPLICANTS', 'THEORY_BOOKING_APPLICANTS', 'THEORY_BOOKING_LESSONS', 'LESSONS_EDIT', 'LESSONS_REPORT']),
};

export default Search;



// WEBPACK FOOTER //
// ./src/containers/search/index.js